import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "@tanstack/react-router";
import { resolvePostLoginRoute } from "@/components/LoginModal";
import { getConfirmedSession } from "@/lib/authSession";

const Login = () => {
  const { openLoginModal } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    // Directe, niet-uitgestelde sessiecheck (authSession.ts) i.p.v. AuthContext's eigen
    // `session`/`loading` — die state kan tot 2s achterlopen door de requestIdleCallback-
    // vertraging die daar puur voor de marketing-homepage-bundle bestaat (zie AuthContext.tsx).
    // Precies deze route (bv. na een Google-OAuth-redirect) betaalde die vertraging het meest.
    getConfirmedSession().then((session) => {
      if (cancelled) return;
      if (session) {
        resolvePostLoginRoute().then((to) => {
          if (!cancelled) navigate({ to, replace: true });
        });
      } else {
        openLoginModal();
        navigate({ to: "/", replace: true });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-dvh flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );
};

export const Route = createFileRoute("/login")({
  head: () => ({
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1, viewport-fit=cover" },
      { name: "robots", content: "noindex, nofollow" },
      { title: "Inloggen | VoxFlow" },
      { name: "description", content: "Log in op je VoxFlow account." },
    ],
  }),
  component: Login,
});
